<template>
	<div class="subtitle">
		<div class="icon-wrapper">
			<img class="subtitle-icon" :src="icon" alt="">
			<span>{{titleName}}</span>
		</div>
		<slot name="right"></slot>
	</div>
</template>


<script>

export default {
	name:'subtitle',
	props: {
		titleName:{},
		icon:{
			default:require("../../../assets/images/global/subtitle-icon.png")
		}
    },
	data(){
		return{

		}
	},

	computed: {

	},
	watch: {

	},

	created() {

	},
	mounted() {

	},

	methods: {

	}
}
</script>



<style lang="scss" scoped>
	.subtitle{
		width: 100%;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		background-color: #EEF9FF;
		border-radius: 2px 2px 0px 0px;
		padding: 0 19px;
		.icon-wrapper{
			display: flex;
			align-items: center;
			color: #333;
			font-weight: bold;
			font-size: 16px;
			.subtitle-icon{
				margin-right: 9px;
			}
		}

	}
</style>